'use client';
import { twMerge } from 'tailwind-merge';
import { IMessage } from '../../message.typings';
import { MessageItemImages } from './message-item-images';
import type { MessageImageLayoutWidths } from '@ui/hooks/file/message-image-layout';

interface IProps {
  files: IMessage['files'];
  className?: string;
  imageLoading?: 'eager' | 'lazy';
  reserveImageSpace?: boolean;
  responsiveImageVariants?: boolean;
  imageLayoutWidths?: MessageImageLayoutWidths;
}
export const MessageItemFiles = ({
  files,
  className,
  imageLoading = 'eager',
  reserveImageSpace = false,
  responsiveImageVariants = false,
  imageLayoutWidths,
}: IProps) => {
  return (
    <div className={twMerge('max-w-[300px]', className)}>
      {files && (
        <MessageItemImages
          images={files.images}
          loading={imageLoading}
          reserveSpace={reserveImageSpace}
          responsiveVariants={responsiveImageVariants}
          imageLayoutWidths={imageLayoutWidths}
        />
      )}
    </div>
  );
};
